export const SEARCH_CACHE_MAX_AGE =
  parseInt(process.env.REACT_APP_CACHE_TTL_SEARCH, 10) || 300; // 5mins
export const CATALOG_CACHE_MAX_AGE =
  parseInt(process.env.REACT_APP_CACHE_TTL_CATALOG, 10) || 900; // 15mins
export const CMS_CACHE_MAX_AGE =
  parseInt(process.env.REACT_APP_CACHE_TTL_CATALOG, 10) || 900; // 15mins
export const BILLBOARD_CACHE_MAX_AGE =
  parseInt(process.env.REACT_APP_CACHE_TTL_BILLBOARD, 10) || 60; // 1min

export const countryCodes = Object.freeze({
  US: 1,
});
